import { useState } from 'react'
import dayjs from 'dayjs'

import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Link from '@components/_mui/Link'
import Typography from '@components/_mui/Typography'

import { TaskStatus } from '@shared/utils'

import { PrescriptionDetailsModal } from '@pages/Prescriptions/Prescription'
import Avatar from '@components/Avatar'
import DateTooltip from '@components/DateTooltip'

import Property from '../../components/Property'
import SelectAssignee from '../../components/SelectAssignee'
import SelectPriority from '../../components/SelectPriority'

export default function TaskCard({ task, locked }) {
  const author = task.author || { fullName: 'Q Care Plus', firstName: 'Q', lastName: 'P' }
  const [rxOpen, setRxOpen] = useState(false)

  return (
    <Paper variant="outlined" sx={styles.card}>
      <Stack sx={styles.body}>
        <Property label="Priority">
          <SelectPriority task={task} disabled={locked} />
        </Property>
        <Property label="Created at">
          <DateTooltip date={task.createdAt}>
            <Typography>{dayjs(task.createdAt).format('L')}</Typography>
          </DateTooltip>
        </Property>
        <Property label="Created by">
          <Stack direction="row" sx={styles.createdBy}>
            <Avatar size="xs" user={author} hover="card" />
            <Typography>{author.fullName}</Typography>
          </Stack>
        </Property>
        {task.status === TaskStatus.Completed && task.updatedAt && (
          <Property label="Completed">
            <DateTooltip date={task.updatedAt}>
              <Typography>{dayjs(task.updatedAt).format('L')}</Typography>
            </DateTooltip>
          </Property>
        )}
        {task.status === TaskStatus.Expired && task.updatedAt && (
          <Property label="Expired">
            <DateTooltip date={task.updatedAt}>
              <Typography>{dayjs(task.updatedAt).format('L')}</Typography>
            </DateTooltip>
          </Property>
        )}
        <Property label="Assignee">
          <SelectAssignee task={task} disabled={locked} />
        </Property>
        {task.relatedModelType === 'Prescription' && (
          <Property label="Related Rx">
            <Link onClick={() => setRxOpen(true)} sx={{ cursor: 'pointer' }}>
              {task.relatedModelId}
            </Link>
            <PrescriptionDetailsModal prescriptionId={task.relatedModelId} open={rxOpen} onClose={() => setRxOpen(false)} />
          </Property>
        )}
        {task.relatedModelType === 'Cbo' && task.relatedModel && (
          <Property label="Related CBO">
            <Stack direction="row" sx={styles.createdBy}>
              <Avatar.CBO size="xs" data={task.relatedModel} card />
              <Typography>{task.relatedModel.name}</Typography>
            </Stack>
          </Property>
        )}
      </Stack>
    </Paper>
  )
}

TaskCard.Loading = function TaskCardLoading() {
  return (
    <Paper variant="outlined" sx={styles.card}>
      <Stack sx={styles.body}>
        <Property label="Priority">
          <Typography>
            <Skeleton width={80} />
          </Typography>
        </Property>
        <Property label="Created at">
          <Typography>
            <Skeleton width={120} />
          </Typography>
        </Property>
        <Property label="Created by">
          <Stack direction="row" sx={styles.createdBy}>
            <Skeleton variant="circular" width={24} height={24} />
            <Typography>
              <Skeleton width={160} />
            </Typography>
          </Stack>
        </Property>
        <Property label="Assignee">
          <Stack direction="row" sx={styles.createdBy}>
            <Skeleton variant="circular" width={24} height={24} />
            <Typography>
              <Skeleton width={130} />
            </Typography>
          </Stack>
        </Property>
      </Stack>
    </Paper>
  )
}

const styles = {
  card: {
    height: '100%',
  },
  body: {
    gap: 1,
    p: 2,
  },
  createdBy: {
    gap: 1,
    alignItems: 'center',
  },
}
